export default class DownloadService {
	constructor(apiService) {
		this.apiService = apiService
	}

	isWebdavConfigured() {
		return this.apiService.callGet('downloads/is_webdav_configured')
	}

	getDownloads() {
		return this.apiService.callGet('downloads')
	}

	getFullRouteForFileDownload() {
		return this.apiService.host + 'download_file/'
	}

	getFullRouteForFilesDownload() {
		return this.apiService.host + 'download_files/'
	}

	downloadFiles(params) {
		return this.apiService.callPost('download_files', params)
	}
}



// WEBPACK FOOTER //
// ./src/service/DownloadService.js